import BaseApi from "./baseApi";

class RebateValueApi extends BaseApi {
  getListByRebateId(queryString) {
    return super.execute(this.Methods.GET, `${this.Urls.rebateValue.getListByRebateId}${queryString}`, null, true)
      .then((res) => {
        return res;
      });
  }

  addOrUpdateMultipleByRebateId(query, params) {
    return super
      .execute(this.Methods.POST, `${this.Urls.rebateValue.addOrUpdateMultipleByRebateId}${query}`, null, true, params)
      .then((res) => {
        return res;
      });
  }
}

export default new RebateValueApi();
